import Shipments from "../../../containers/shipments/shipments";
import { getApiUrl } from "../../../utils/baseUrl";
import { filterTypeDictionary as filterType, analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, redirectingProfileEnum, categoryType } from "../../../core/global/global-country-dictionary";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";
import { profileType } from "@utils/enum";

export const analyticDropdownOptions = [
  { value: "shipments", label: "Number of Shipments", two_table_header: "Total Shipments" },
  { value: "value", label: "Total Shipment Value (USD)", two_table_header: "Total Value (USD)" },
];
export const trendsDropdownOptions = [
  { value: "shipments", label: "Shipments", table_header: "Total Shipments" },
  { value: "value", label: "Value (USD)", table_header: "Total Value (USD)" },
];
export const defaultData = {
  name: "Vietnam Imports",
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  analyticsDefault: analyticDropdownOptions[0].value,
  analyticsRangeDownloadPresent: true,
  isFilterGroupingPresent: true,
  isViewAllGridNew: true,
  showUiTrends: true,
  isShipmentGridNew: true,
  exportPDFInAnalytics: false,
  minimumDateAllowed: "2020-01-01",
  isImpExpGraph: true,
  isUIGridNew: true,
  isUEGridNew: true,
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
  },
  importer_exporter_graph_sort__options: [
    { value: "shipment_value", label: "Value (USD)", table_header: "Total Shipment Value(USD)" },
    { value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" },
  ],
  apiEndPoints: {
    getArrivalDate: getApiUrl("intelSearchVietnamImportLatestArrivalDate"),
    getSearchResult: getApiUrl("intelSearchVietnamImport"),
    getAnalyticsData: getApiUrl("analytics/intelAnalyticsVietnamImport"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel_vietnam_imports"),
    downloadUniqueImporterExporter: getApiUrl("create_excel_vietnam_imports"),
    getShipmentByID: getApiUrl("intelSearchVietnamImportShipmentByID"),
    getShipmentDownloadData: getApiUrl("renderToPdfVietnamImports"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearchPayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/intelAnalyticsVietnamImportViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("intelSearchVietnamImportGraph"),
  },
  isAdvancedSearchAvailable: false,
  country_small: globalCountryDetails.vn_import.country_small,
  countryCaps: globalCountryDetails.vn_import.country_caps,
  product_id: globalCountryDetails.vn_import.product_id,
  compare_product_id: globalCountryDetails.vn_import.compareProduct,
  country_CamelCase: globalCountryDetails.vn_import.product_id,
  countryCode: globalCountryDetails.vn_import.countryCode,
  countryType: globalCountryDetails.vn_import.countryType,
  manyCountryType: globalCountryDetails.vn_import.manyCountryType,
  countryTypeCode: globalCountryDetails.vn_import.countryTypeCode,
  redirectionID: globalCountryDetails.vn_import.redirectionID,
  analyticsCountryID: globalCountryDetails.vn_import.analyticsCountryID,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Shipment Date Range",
  monthRangeHeading: "Month of Import",
  picker: {
    monthPicker: false,
    datePicker: true,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    exporters: true,
    importers: true,
    whatYouAreMissing: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: true,
    product_hscode: true,
    exporters: true,
    importers: true,
    allCategory: true,
    chemical_description: true,
  },
  searchCategoryList: globalCountryDetails.vn_import.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    consignee: "derivedConsigneeMasterName",
    shipper: "derivedShipperMasterName",
    value: "shipmentValue",
    sixDigitHsCode: "sixDigitHsCode",
    portOfLading: "portOfLading",
    portOfUnlading: "portOfUnlading",
    productCategory: "productCategory",
  },
  filterObj: {
    originCountryRegion: "originCountryRegion",
    countryOfDestinationRegion: "countryOfDestinationRegion",
    consigneeName: "consigneeName",
    consigneeType: "consigneeType",
    consigneeDistrict: "consigneeDistrict",
    consigneeProvinceRegion: "consigneeProvinceRegion",
    shipperName: "shipperName",
    shipperType: "shipperType",
    shipperCountryRegion: "shipperCountryRegion",
    portOfLading: "portOfLading",
    portOfLadingCountryRegion: "portOfLadingCountryRegion",
    portOfUnlading: "portOfUnlading",
    customsHouseName: "customsHouseName",
    customsClearanceWarehouseName: "customsClearanceWarehouseName",
    transportMode: "transportMode",
    incoterm: "incoterm",
    typeOfImportCode: "typeOfImportCode",
    hsCode: "hsCode",
    paymentMethod: "paymentMethod",
    shipmentValue: "shipmentValue",
    derivedShipperMasterName: "derivedShipperMasterName",
    derivedConsigneeMasterName: "derivedConsigneeMasterName",
    sixDigitHsCode: "sixDigitHsCode",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    quantityUnit: "quantityUnit",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",

    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountryRegion",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountryRegion",
  },
  booleanFilterObj: {
    exclude_blank_consignee: "exclude_blank_consignee",
    exclude_blank_shipper: "exclude_blank_shipper",
  },
  boxRangeFilterList: {
    shipmentValue: "shipmentValue",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  boxFilterObj: {
    shipmentValue: [],
    perUnitValue: [],
    quantityRange: [],
  },
  localisationFilterObj: {
    // originCountryRegion: "originCountry",
    countryOfDestinationRegion: "countryOfDestination",
    consigneeProvinceRegion: "consigneeProvince",
    shipperCountryRegion: "shipperCountry",
    portOfLadingCountryRegion: "portOfLadingCountry",

    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountry",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountry",
  },
  emptyFilterObj: {
    // originCountryRegion: [],
    countryOfDestinationRegion: [],
    consigneeName: [],
    consigneeType: [],
    consigneeDistrict: [],
    consigneeProvinceRegion: [],
    shipperName: [],
    shipperType: [],
    shipperCountryRegion: [],
    portOfLading: [],
    portOfLadingCountryRegion: [],
    portOfUnlading: [],
    customsHouseName: [],
    customsClearanceWarehouseName: [],
    transportMode: [],
    incoterm: [],
    typeOfImportCode: [],
    hsCode: [],
    paymentMethod: [],
    shipmentValue: [],
    sections: [],
    derivedShipperMasterName: [],
    derivedConsigneeMasterName: [],
    sixDigitHsCode: [],
    productCategory: [],
    industryCategory: [],
    quantityUnit: [],
    perUnitValue: [],
    quantityRange: [],

    consigneeJurisdictionCountryRegion: [],
    shipperJurisdictionCountryRegion: [],
  },
  defaultBooleanFilterObj: {
    exclude_blank_consignee: false,
    exclude_blank_shipper: false,
  },
  selectAll: {
    originCountryRegion: false,
    countryOfDestinationRegion: false,
    consigneeName: false,
    consigneeType: false,
    consigneeDistrict: false,
    consigneeProvinceRegion: false,
    shipperName: false,
    shipperType: false,
    shipperCountryRegion: false,
    portOfLading: false,
    portOfLadingCountryRegion: false,
    portOfUnlading: false,
    customsHouseName: false,
    customsClearanceWarehouseName: false,
    transportMode: false,
    incoterm: false,
    typeOfImportCode: false,
    hsCode: false,
    paymentMethod: false,
    shipmentValue: false,
    sections: false,
    derivedShipperMasterName: false,
    derivedConsigneeMasterName: false,
    sixDigitHsCode: false,
    productCategory: false,
    industryCategory: false,
    quantityUnit: false,
    perUnitValue: false,
    quantityRange: false,

    consigneeJurisdictionCountryRegion: false,
    shipperJurisdictionCountryRegion: false,
  },
  specialMappingFields: {
    derived_hs_codes_string: {
      derived_hs_codes_string: {
        key: "derived_hs_codes_string",
        value: "",
      },
      derived_hs_codes_string_estimated: {
        key: "derived_hs_codes_string_estimated",
        value: "",
      },
      derived_hs_codes_string_estimated_is_present: {
        key: "derived_hs_codes_string_estimated_is_present",
        value: "Estimated HSCode",
      },
      fallback: "Not Available",
    },
    derived_shipment_value: {
      derived_shipment_value: {
        key: "derived_shipment_value",
        value: "",
      },
      derived_shipment_value_is_present: {
        key: "derived_shipment_value_is_present",
        value: "",
      },
      fallback: "Not Available",
    },
    shipper_party_name: {
      shipper_party_name: {
        key: "shipper_party_name",
        value: "",
      },
      fallback: "Not Declared",
    },
  },
  normalfilterList: [
    { heading: "Filter by Shipper Standardized Name", categoryName: "shipperDetails", eventKey: "25", key: "derivedShipperMasterName", type: filterType.normalFilter, label: "Shipper Standardized Name", viewAllPlaceHolder: "Search in Shipper Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Standardized Name", categoryName: "consigneeDetails", eventKey: "26", key: "derivedConsigneeMasterName", type: filterType.normalFilter, label: "Consignee Standardized Name", viewAllPlaceHolder: "Search in Consignee Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Name", categoryName: "shipperDetails", eventKey: "1", key: "shipperName", type: filterType.normalFilter, label: "Shipper Name", viewAllPlaceHolder: "Search in Shipper Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Name", categoryName: "consigneeDetails", eventKey: "7", key: "consigneeName", type: filterType.normalFilter, label: "Consignee Name", viewAllPlaceHolder: "Search in Consignee Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Type", categoryName: "shipperDetails", eventKey: "2", key: "shipperType", type: filterType.normalFilter, label: "Shipper Type", viewAllPlaceHolder: "Search in Shipper Type Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Export", categoryName: "shipperDetails", eventKey: "5", key: "shipperCountryRegion", altKey: "shipperCountry", type: filterType.localizeFilter, label: "Country of Export", viewAllPlaceHolder: "Search in Country of Export Filter", emptyFilterText: "", searchFilterString: "" },
    // { heading: "Filter by Country of Export", categoryName: "shipperDetails", eventKey: "6", key: "originCountryRegion", altKey: "originCountry", type: filterType.localizeFilter, label: "Country of Export", viewAllPlaceHolder: "Search in Country of Export Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Import", categoryName: "consigneeDetails", eventKey: "6", key: "countryOfDestinationRegion", altKey: "countryOfDestination", type: filterType.localizeFilter, label: "Country of Import", viewAllPlaceHolder: "Search in Country of Import Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Type", categoryName: "consigneeDetails", eventKey: "8", key: "consigneeType", type: filterType.normalFilter, label: "Consignee Type", viewAllPlaceHolder: "Search in Consignee Type Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee District", categoryName: "consigneeDetails", eventKey: "9", key: "consigneeDistrict", type: filterType.normalFilter, label: "Consignee District", viewAllPlaceHolder: "Search in Consignee District", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Province", categoryName: "consigneeDetails", eventKey: "10", key: "consigneeProvinceRegion", altKey: "consigneeProvince", type: filterType.localizeFilter, label: "Consignee Province", viewAllPlaceHolder: "Search in Consignee Province Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Port Of Lading", categoryName: "ports", eventKey: "11", key: "portOfLading", type: filterType.normalFilter, label: "Port Of Lading", viewAllPlaceHolder: "Search in Port Of Lading Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Port Of Lading Country", categoryName: "ports", eventKey: "12", key: "portOfLadingCountryRegion", altKey: "portOfLadingCountry", type: filterType.localizeFilter, label: "Port Of Lading Country", viewAllPlaceHolder: "Search in Port Of Lading Country Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Port Of Unlading", categoryName: "ports", eventKey: "13", key: "portOfUnlading", type: filterType.normalFilter, label: "Port Of Unlading", viewAllPlaceHolder: "Search in Port Of Unlading Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Customs House Name", categoryName: "customsDetails", eventKey: "15", key: "customsHouseName", type: filterType.normalFilter, label: "Customs House Name", viewAllPlaceHolder: "Search in Customs House Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Customs Clearance Warehouse Name", categoryName: "customsDetails", eventKey: "16", key: "customsClearanceWarehouseName", type: filterType.normalFilter, label: "Customs Clearance Warehouse Name", viewAllPlaceHolder: "Search in Customs Clearance Warehouse Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Product Category", categoryName: "cargoDetails", eventKey: "9", key: "productCategory", type: filterType.normalFilter, label: "Product Category", viewAllPlaceHolder: "Type to Search in Product Category Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Industry Group", categoryName: "cargoDetails", eventKey: "33", key: "industryCategory", type: filterType.normalFilter, label: "Industry Group", viewAllPlaceHolder: "Type to Search in Industry Group Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by HS Code", categoryName: "cargoDetails", eventKey: "18", key: "hsCode", type: filterType.hsCodeFilter, label: "HS Code", viewAllPlaceHolder: "Search in HS Code Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipment Value", categoryName: "cargoDetails", eventKey: "19", key: "shipmentValue", type: filterType.boxFilter, label: "Shipment Value (USD)", viewAllPlaceHolder: "Search in Value Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Mode of Transportation", categoryName: "freightType", eventKey: "21", key: "transportMode", type: filterType.normalFilter, label: "Mode of Transportation", viewAllPlaceHolder: "Search in Mode of Transportation Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Incoterm Filter", categoryName: "freightType", eventKey: "22", key: "incoterm", type: filterType.normalFilter, label: "Incoterm", viewAllPlaceHolder: "Search in Incoterm Filter", emptyFilterText: "", searchFilterString: "", isNoTransform: true },
    { heading: "Filter by Type of Import Code Filter", categoryName: "freightType", eventKey: "23", key: "typeOfImportCode", type: filterType.normalFilter, label: "Type of Import Code", viewAllPlaceHolder: "Search in Type of Import Code Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Type of Payment Method Filter", categoryName: "freightType", eventKey: "24", key: "paymentMethod", type: filterType.normalFilter, label: "Payment Method", viewAllPlaceHolder: "Search in Payment Method Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by 6 digit HS Code", categoryName: "cargoDetails", eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Quantity Unit", categoryName: "cargoDetails", eventKey: "32", key: "quantityUnit", additionalKey: "quantityRange", type: filterType.normalFilter, label: "Quantity", viewAllPlaceHolder: "Search Quantity Unit", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: true, isParanthesesCapital: false, additionalType: "multiSelectRangeFilter" },
    { heading: "Filter by Per Unit Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "32", key: "perUnitValue", type: filterType.multiSelectRangeFilter, label: "Per Unit Value (USD)", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false, isParanthesesCapital: false },

    {
      heading: "Filter by Consignee Jurisdiction Country",
      categoryName: "consigneeDetails",
      eventKey: "25",
      key: "consigneeJurisdictionCountryRegion",
      altKey: "consigneeJurisdictionCountry",
      type: "localization-filter",
      label: "Consignee Jurisdiction Country",
      viewAllPlaceHolder: "Search Consignee Jurisdiction Country",
      emptyFilterText: "",
      searchFilterString: "",
    },
    {
      heading: "Filter by Shipper Jurisdiction Country",
      categoryName: "shipperDetails",
      eventKey: "25",
      key: "shipperJurisdictionCountryRegion",
      altKey: "shipperJurisdictionCountry",
      type: "localization-filter",
      label: "Shipper Jurisdiction Country",
      viewAllPlaceHolder: "Search Shipper Jurisdiction Country",
      emptyFilterText: "",
      searchFilterString: "",
    },
  ],
  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: false, key: "uniqueImportExporterWeight" },
    { isVisible: false, key: "uniqueImportExporterTeu" },
    { isVisible: true, key: "uniqueImportExporterValue" },
  ],
  highLightedColumnList: [
    { key: "bill_of_lading", label: "Bill of Lading Number" },
    { key: "derived_hs_code", label: "HS Code" },
    { key: "shipper_name", label: "Shipper Name" },
    { key: "derived_shipper_master_name", label: "Shipper Standardized Name" },
    { key: "derived_consignee_name_english", label: "Consignee Name" },
    { key: "derived_consignee_master_name", label: "Consignee Standardized Name" },
    { key: "shipper_address", label: "Shipper Address" },
    { key: "consignee_address", label: "Consignee Address" },
    { key: "product_description_english", label: "Product Description" },
    { key: "product_description_vietnamese", label: "Product Description Vietnamese" },
    { key: "vessel_name", label: "Vessel Name" },
    { key: "invoice_number", label: "Invoice Number" },
    { key: "derived_consignee_registration_number", label: "Consignee Registration Number" },
    { key: "derived_customs_branch_name", label: "Custom House Name" },
    { key: "derived_customs_branch_name_abv", label: "Custom House Name Abbreviation" },
    { key: "customs_clearance_warehouse_name", label: "Custom Clearance Warehouse Name" },
    { key: "declaration_number", label: "Declaration Number" },
  ],
  shipmentSorting: [
    { columnKey: "corrected_declaration_date", value: "date", isDefault: true },
    { columnKey: "derived_shipment_value_usd", value: "shipment_value", isDefault: false },
  ],
  exporterSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: false },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: true },
  ],
  importerSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: false },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: true },
  ],
  sortKeyMap: {
    date: "corrected_declaration_date",
    shipment_value: "derived_shipment_value_usd",
  },
  sortKeyUniqueImpExpMap: {
    shipment_value: "shipment_value",
    date: "doc_count",
  },
  analyticsHeaderItems: [
    { label: "Total Number of Shipments", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    { label: "Total Shipment Value (USD)", key: "total_value", valuePrefix: "USD", valueSuffix: "" },
  ],
  analyticsFieldsMapping: [
    { key: "trade_country_of_export_to_import", filterKey1: "shipperCountryRegion", filterKey2: "countryOfDestinationRegion", label: "Trade Routes (Country of Export → Country of Import)", headerOne: "Country of Export", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "trends", filterKey: "", label: "Import Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false },
    { key: "derived_country_of_origin", filterKey: "shipperCountryRegion", label: "Countries of Export", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "derived_port_of_unlading_country_combined" },
    { key: "derived_port_of_lading_country_combined", filterKey: "portOfLading", label: "Ports of Lading", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_port_of_unlading_country_combined", profileType: redirectingProfileEnum.portOfLading.key, isFavourite: true, profileTypeKey: profileType.ports },
    { key: "derived_port_of_lading_country", filterKey: "portOfLadingCountryRegion", label: "Ports of Lading Country", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "derived_port_of_unlading_country_combined" },
    // { key: "derived_shipper_country", filterKey: "shipperCountryRegion", label: "Shipper Countries", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "derived_port_of_unlading_country_combined" },
    { key: "derived_port_of_unlading_country_combined", filterKey: "portOfUnlading", label: "Ports of Unlading", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_port_of_lading_country_combined", profileType: redirectingProfileEnum.portOfUnlading.key, isFavourite: true, profileTypeKey: profileType.ports },
    { key: "derived_consignee_district_country_combined", filterKey: "consigneeDistrict", label: "Consignee Districts", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_origin" },
    { key: "derived_consignee_province_country_combined", filterKey: "consigneeProvinceRegion", label: "Consignee Provinces", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_origin" },
    { key: "derived_customs_branch_name", filterKey: "customsHouseName", label: "Customs Houses", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_port_of_lading_country_combined" },
    { key: "customs_clearance_warehouse_name", filterKey: "customsClearanceWarehouseName", label: "Custom Clearance Warehouses", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_port_of_lading_country_combined" },
    // { key: 'vessel_name', filterKey: 'vesselName', label: 'Vessels', type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: 'derived_country_of_origin' },
    { key: "hs_code", headerLabel: "HS Code", filterKey: "hsCode", label: "2-digit HS Codes", type: analyticsType.hsCode, showTrends: false, showlevelTwo: false },
    { key: "mode_of_transport", filterKey: "transportMode", label: "Modes of Transportation", type: analyticsType.pieChart, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_origin" },
    // { key: "trade_country_of_origin_to_customs_branch", filterKey1: "originCountryRegion", filterKey2: "customsHouseName", label: "Trade Routes (Country of Export → Custom House)", headerOne: "Country of Export", headerTwo: "Custom House", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    // { key: "trade_country_of_origin_to_port_of_unlading", filterKey1: "originCountryRegion", filterKey2: "portOfUnlading", label: "Trade Route (Country of Export → Port of Unlading)", headerOne: "Country of Export", headerTwo: "Port of Unlading", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "trade_port_of_lading_to_port_of_unlading", filterKey1: "portOfLading", filterKey2: "portOfUnlading", label: "Trade Routes (Port of Lading → Port of Unlading)", headerOne: "Port of Lading", headerTwo: "Port of Unlading", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    // { key: "trade_port_of_lading_to_customs_branch", filterKey1: "portOfLading", filterKey2: "customsHouseName", label: "Trade Route (Port of Lading → Custom House)", headerOne: "Port of Lading", headerTwo: "Customs House", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    // { key: 'trade_shipper_district_to_consignee_district', filterKey1: 'shipperDistrict', filterKey2: 'consigneeDistrict', label: 'Trade Routes (Shipper District → Consignee District)', headerOne: 'Shipper District', headerTwo: 'Consignee District', filterOne: 'filterField1', filterTwo: 'filterField2', keyOne: 'field1Country', keyTwo: 'field2Country', cityOne: 'field1', cityTwo: 'field2', keyOneCountryCode: 'field1CountryCode',  keyTwoCountryCode: 'field2CountryCode', type: analyticsType.topTwo, showTrends: true, grpType: 'multi', showlevelTwo: true, defaultKey: 'derived_consignee_master_name' },
    // {
    //   key: "trade_country_of_origin_to_port_of_lading_to_port_of_unlading_to_customs_branch",
    //   filterKey1: "originCountryRegion",
    //   filterKey2: "portOfLading",
    //   filterKey3: "portOfUnlading",
    //   filterKey4: "customsHouseName",
    //   label: "Trade Routes (Country of Export → Port of Lading → Port of Unlading → Custom House)",
    //   filterOne: "filterField1",
    //   filterTwo: "filterField2",
    //   filterThree: "filterField3",
    //   filterFour: "filterField4",
    //   headerOne: "Country of Export",
    //   headerTwo: "Port Of Lading",
    //   headerThree: "Port Of Unlading",
    //   headerFour: "Custom House",
    //   keyOne: "field1Country",
    //   keyTwo: "field2Country",
    //   keyThree: "field3Country",
    //   keyFour: "field4Country",
    //   cityOne: "field1",
    //   cityTwo: "field2",
    //   cityThree: "field3",
    //   cityFour: "field4",
    //   keyOneCountryCode: "field1CountryCode",
    //   keyTwoCountryCode: "field2CountryCode",
    //   keyThreeCountryCode: "field3CountryCode",
    //   keyFourCountryCode: "field4CountryCode",
    //   type: analyticsType.topFour,
    //   grpType: "multi",
    //   showTrends: true,
    //   showlevelTwo: true,
    //   defaultKey: "derived_consignee_master_name",
    // },
    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
  ],
  searchTableColumns: [
    { key: "", name: "View", selector: "", dataTip: "", type: "viewShipment", button: true, staticField: true, grow: 0, miWidth: "40px", maWidth: "40px" },
    { key: "s_no", name: "S No", selector: "s_no", dataTip: "", type: "", maxWidth: "84px !important", minWidth: "84px !important", grow: 0, wrap: true, staticField: true, miWidth: "60px", maWidth: "60px" },
    { key: "corrected_declaration_date", name: "Declaration Date", selector: "corrected_declaration_date", dataTip: "", type: "", dateFormat: "MMM DD, YYYY", sortable: true, grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "matched_column", name: "Matching Fields", selector: "matched_column", dataTip: "", type: "matchingField", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_hs_code", name: "HS Code", selector: "derived_hs_code", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "100px", maWidth: "100px" },
    { key: "product_description_english", name: "Product Description", selector: "product_description_english", tooltipValue: "product_description_english", type: "", grow: 2, wrap: true, isSliceEnabled: true, sliceLength: 30, miWidth: "120px", maWidth: "120px" },
    // { key: "product_description_vietnamese", name: 'Product Description Vietnamese', selector: 'product_description_vietnamese', tooltipValue: 'product_description_vietnamese', type: '', grow: 2, wrap: true, isSliceEnabled: true, sliceLength: 30, miWidth: "120px", maWidth: "120px" },
    { key: "shipment_quantity", name: "Quantity", selector: "shipment_quantity", secondarySelector: "derived_shipment_quantity_unit", dataTip: "", type: "", grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "100px", maWidth: "100px" },
    { key: "derived_shipper_master_name", name: "Shipper Name", selector: "derived_shipper_master_name", alternateSelector: "shipper_name", id: "derived_shipper_master_company_id", dataTip: "", type: "companyRedirect", companyType: "E", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_consignee_master_name", name: "Consignee Name", selector: "derived_consignee_master_name", alternateSelector: "consignee_name", id: "derived_consignee_master_company_id", dataTip: "", type: "companyRedirect", companyType: "I", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_country_of_origin", name: "Country of Export", selector: "derived_country_of_origin", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_shipment_value_usd", name: "Shipment Value (USD)", selector: "derived_shipment_value_usd", dataTip: "", type: "", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "140px", maWidth: "140px" },
  ],
  exporterTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "", isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Exported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Exported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  importerTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "shipment_value", name: "Shipment Value (USD)", sortable: true, selector: "shipment_value", dataTip: "", type: "", isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Imported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Imported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Date of Declaration", value: "corrected_declaration_date", dateFormat: true, monthFormat: false },
        { label: "Date of Arrival", value: "date_of_arrival", dateFormat: true, monthFormat: false },
        { label: "Finished Checking Date", value: "finished_checking_date", dateFormat: true, monthFormat: false },
        { label: "Approved Clearance Date", value: "approved_clearance_date", dateFormat: true, monthFormat: false },
        { label: "Declaration Number", value: "declaration_number" },
        { label: "Bill of Lading Number", value: "bill_of_lading", capitalize: "true" },
        { label: "Invoice Number", value: "invoice_number" },
        { label: "Mode of Transportation", value: "derived_mode_of_transportation" },
        { label: "HS Code", value: "derived_hs_code" },
        { label: "Payment Method", value: "derived_payment_method_description_combined" },
        { label: "Incoterm", value: "derived_incoterm_code_description_combined" },
        { label: "Type of Import", value: "derived_type_of_import_code_description_combined" },
      ],
    },
    {
      id: 2,
      title: "Shipment Origin Details",
      isConnectedColumn: true,
      isCompactHeader: true,
      growValue: 6,
      isHeader: false,
      imgUrl: "",
      data: [
        { label: "Country of Export", value: "derived_country_of_export", countryFlag: true, countryCodeField: "derived_country_of_export_code", tooltip: true, tooltipField: "shipper_country_code" },
        // { label: "Country of Export", value: "derived_country_of_origin", tooltip: true, tooltipField: "country_of_origin_code" },
        { label: "Port of Lading", value: "derived_port_of_lading", tooltip: true, tooltipField: "port_of_lading_code", tooltipPrefix: "Port Of Lading Code: ", type: "redirect", redirectionID: "derived_port_of_lading_master_id", profileType: redirectingProfileEnum.portOfLading.key },
        { label: "Port of Lading Country", value: "derived_port_of_lading_country", tooltip: true, tooltipField: "port_of_lading_country_code" },
        { label: "Shipper Standardized Name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "", derivedCompanyKey: "derived_shipper_master_name", tradeDirection: "E" },
        { label: "Shipper Name", value: "shipper_name" },
        { label: "Shipper Type", value: "derived_is_exporter", tooltip: false, tooltipField: "" },
        { label: "Shipper Address", value: "shipper_address", isReadMore: true, readMoreLength: 45 },
        { label: "Shipper City", value: "shipper_city" },
        { label: "Shipper District", value: "shipper_district" },
        // { label: "Shipper Country", value: "derived_shipper_country", tooltip: true, tooltipField: "shipper_country_code" },

        {
          label: "Shipper Jurisdiction Country",
          value: "derived_shipper_jurisdiction_country",
          countryFlag: true,
          countryCodeField: "derived_shipper_jurisdiction_country_code",
        },
      ],
    },
    {
      id: 3,
      title: "Shipment Destination Details",
      growValue: 6,
      isHeader: false,
      isCompactHeader: true,
      imgUrl: "",
      data: [
        { label: "Port of Unlading", value: "derived_port_of_unlading", tooltip: true, tooltipField: "port_of_unlading_code", tooltipPrefix: "Port Of Unlading Code: ", type: "redirect", redirectionID: "derived_port_of_unlading_master_id", profileType: redirectingProfileEnum.portOfUnlading.key },
        { label: "Country of Import", value: "derived_country_of_import", countryFlag: true, countryCodeField: "derived_country_of_import_code" },
        { label: "Consignee Standardized Name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "", derivedCompanyKey: "derived_consignee_master_name", tradeDirection: "I" },
        { label: "Consignee Name", value: "derived_consignee_name_english" },
        { label: "Consignee Name (Vietnamese)", value: "consignee_name_vn" },
        { label: "Consignee Registration Number", value: "derived_consignee_registration_number" },
        { label: "Consignee Type", value: "derived_is_importer" },
        { label: "Consignee Address", value: "consignee_address_english", isReadMore: true, readMoreLength: 45 },
        { label: "Consignee District", value: "derived_consignee_district" },
        { label: "Consignee Province", value: "derived_consignee_province" },
        { label: "Consignee Country", value: "derived_consignee_country" },
        { label: "Consignee Phone Number", value: "consignee_phone_number" },

        {
          label: "Consignee Jurisdiction Country",
          value: "derived_consignee_jurisdiction_country",
          countryFlag: true,
          countryCodeField: "derived_consignee_jurisdiction_country_code",
        },
      ],
    },
    {
      id: 4,
      title: "Customs Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
      data: [
        { label: "Customs House Name", value: "derived_customs_branch_name", capitalize: "true", tooltip: true, tooltipField: "derived_customs_branch_name_abv" },
        { label: "Custom Clearance Warehouse Name", value: "customs_clearance_warehouse_name", capitalize: true, tooltip: true, tooltipField: "customs_clearance_warehouse_code" },
      ],
    },
    {
      id: 5,
      title: "Carrier Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [{ label: "Vessel Name", value: "vessel_name", capitalize: "true" }],
    },
    {
      id: 6,
      title: "Cargo Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "Number Of Containers", value: "number_of_containers", isCommaFormat: true },
        { label: "Product Description", value: "product_description_english" },
        { label: "Product Description (Vietnamese)", value: "product_description_vietnamese" },
        { label: "Declaration Gross Weight", value: "total_gross_weight", valueSuffix: " kg", isCommaFormat: true },
        { label: "Declaration Quantity", value: "total_quantity", dynamicUnit: true, unitField: "derived_total_quantity_unit", tooltip: true, tooltipField: "quantity", tooltipField2: "unit_of_measure_spanish", isCommaFormat: true },
        { label: "Shipment Quantity", value: "shipment_quantity", dynamicUnit: true, unitField: "derived_shipment_quantity_unit", tooltip: true, tooltipField: "quantity", tooltipField2: "unit_of_measure_spanish", isCommaFormat: true },
        { label: "Declaration Invoice Value", value: "derived_total_invoice_value_usd", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Declaration Taxable Value", value: "derived_total_taxable_value_usd", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Declaration Freight ", value: "total_freight_usd", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Shipment Value", value: "derived_shipment_value_usd", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
      ],
    },
  ],
  onboardingSteps: [
    { selector: "#reacttourdaterange", disableInteraction: true, header: "", description: "Customize your shipment basis payment date", float: "", position: "left" },
    { selector: "#reacttourFilter", disableInteraction: true, header: "Filters Button", description: "Use filters to get most relevant shipments for you", float: "right", position: "right" },
    { selector: "#reacttourMainSearch", disableInteraction: true, header: "Start searching for Vietnam Imports Shipments", description: "HS Codes and Consignees", float: "right", position: "bottom" },
    { selector: "#nav-tab", disableInteraction: true, header: "", description: "View unique consignees and shippers in the search result and add them to your prospect list.", float: "right", position: "bottom" },
    { selector: ".saved-search-button", disableInteraction: true, header: "", description: "Reload from Saved Searches, for quick shipments data access.", float: "", position: "bottom" },
  ],
  defaultUeUiSecondLevelKey: "derived_country_of_origin",
  twoColumnMapping: {
    trade_country_of_export_to_import: "Trade Routes (Country of Export → Country of Import)",
    derived_consignee_master_name: "Unique Importers",
    derived_shipper_master_name: "Unique Exporters",
    derived_country_of_origin: "Countries of Export",
    derived_port_of_lading_country_combined: "Top Ports of Lading",
    derived_port_of_lading_country: "Top Ports of Lading Country",
    // derived_shipper_city_country_combined: "Top Shipper Cities",
    // derived_shipper_district_country_combined: "Top Shipper Districts",
    derived_shipper_country: "Top Shipper Countries",
    derived_port_of_unlading_country_combined: "Ports of Unlading",
    derived_consignee_district_country_combined: "Consignee Districts",
    derived_consignee_province_country_combined: "Consignee Provinces",
    derived_customs_branch_name: "Custom Houses",
    customs_clearance_warehouse_name: "Custom Clearance Warehouses",
    // vessel_name: "Vessels",

    // trade_country_of_origin_to_customs_branch: "Trade Routes (Country of Export → Custom House)",
    // trade_country_of_origin_to_port_of_unlading: "Trade Routes (Country of Export → Port of Unlading)",
    trade_port_of_lading_to_port_of_unlading: "Trade Routes (Port of Lading → Port of Unlading)",
    // trade_port_of_lading_to_customs_branch: "Trade Routes (Port of Lading → Custom House)",
    // trade_shipper_district_to_consignee_district: "Trade Routes (Shipper District → Consignee District)",
    // trade_country_of_origin_to_port_of_lading_to_port_of_unlading_to_customs_branch: "Trade Routes (Country of Export → Port of Lading → Port of Unlading → Custom House)",
  },
};

const VietnamImportSearch = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default VietnamImportSearch;
